import vue from 'vue'
// import { actionDelete } from '@/components/tools/index.js'
import { sendMessage } from '@/assets/js/tools'
const that = vue.prototype
export default {
  className: 'drawRecords',
  fields: [
    {
      name: 'user',
      disabled: true
    },
    {
      name: 'prize',
      disabled: true
    },
    'logisticsNumber',
    {
      name: 'isIssue',
      disabled: true
    }
  ],
  search: [
    {
      name: 'prize',
      disabled: false
    },
    {
      name: 'isIssue',
      disabled: false
    }
  ],
  action: {
    create: false,
    edit: {
      type: 'row',
      text: '填写单号',
      hidden ({ record, tags }) {
        if (record && record.isIssue) return true
      }
    },
    delete: false,
    enter: {
      type: 'row',
      text: '点击发放',
      hidden ({ record, tags }) {
        if (record && record.isIssue) return true
      },
      callback: async ({ record, vm }) => {
        // 修改状态
        if (!record.logisticsNumber) {
          throw that.$notification['error']({
            message: '请您填写物流单号',
            description: '请重新尝试'
          })
        }
        await vm.$modelAjax.put('drawRecords', record.objectId, { isIssue: true }).catch(() => {
          throw that.$notification['error']({
            message: '发放状态修改失败',
            description: '请重新尝试'
          })
        })
        // 短信通知用户奖品发放状态
        await sendMessage([record.user.phone], `感谢您对平台支持，您的奖品已在路上，物流单号为：${record.logisticsNumber}，请注意查收。`)
        that.$notification['success']({
          message: '发放状态已修改为已发放',
          description: '意见状态修改成功'
        })
        vm.refresh()
      }
    },
    hasEnter: {
      type: 'row',
      text: '已发放',
      hidden ({ record, tags }) {
        if (record && record.isIssue !== true) return true
      },
      callback: async ({ vm }) => {
        throw that.$notification['error']({
          message: '发放状态为已发放状态',
          description: '请勿重复点击'
        })
      }
    }
  },
  hooks: {
  }
}
